import { render, staticRenderFns } from "./sub-editor.vue?vue&type=template&id=ff5e0860&scoped=true&"
import script from "./sub-editor.vue?vue&type=script&lang=js&"
export * from "./sub-editor.vue?vue&type=script&lang=js&"
import style0 from "./sub-editor.vue?vue&type=style&index=0&id=ff5e0860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5e0860",
  null
  
)

export default component.exports